var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8696 18.9819C38.727 27.6126 31.6133 41.6969 3.67426 38.0053C20.1332 38.0053 28.3325 28.7375 28.3325 23.8011C28.3325 20.5417 25.6025 18.2859 20.3052 18.0345V21.2058L19.2359 20.6419L2.18254 11.6622L0.956993 11.0177L2.18262 10.3708L19.2357 1.39125L20.3051 0.827347V5.47094C31.8276 5.75141 38.8094 11.7873 38.8696 18.5741C38.8709 18.7082 38.8719 18.8448 38.8696 18.9819ZM35.3857 19.3406C35.473 12.6566 29.4743 7.92086 18.8453 7.72446V3.24688L4.08934 11.0155L18.8454 18.7866V13.662C29.7991 13.8434 34.6141 18.369 32.9274 27.0776C34.5561 24.3307 35.3547 21.7124 35.3858 19.3407L35.3857 19.3406Z",
    fill: "#654AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundLogo);
export default __webpack_public_path__ + "static/media/refund_logo.4cf91542f0db8b42642894f2ebb36bcc.svg";
export { ForwardRef as ReactComponent };